import { render, staticRenderFns } from "./VendorTabsNotes.vue?vue&type=template&id=902399f0&scoped=true&"
import script from "./VendorTabsNotes.vue?vue&type=script&lang=js&"
export * from "./VendorTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902399f0",
  null
  
)

export default component.exports